module.exports = __webpack_public_path__ + "Lato-SemiboldItalic.82b587d9f743383fb03f.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-SemiboldItalic.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-SemiboldItalic.eot
// module chunks = styles